import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { FragmentNames, ScoreFlexListAliases } from '../../../../codegen/index';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';

@Controller ({ component: ScoreFlexListAliases.LAYOUT_SCORE_FLEX_LIST, fragment: FragmentNames.SCORE_FLEX_LIST })
export default class ScoreFlexListController extends BaseController {

  @Inject(ScoreFlexListAliases.PANEL_GLOBAL_ACTIONS)
  private panelGlobalActions!: PanelAPI;

  @OnMount({ target: ScoreFlexListAliases.LAYOUT_SCORE_FLEX_LIST })
  handlePanelGlobalActionsMount(): void {
    this.panelGlobalActions.setVisible(false);
  }

}
